export class InactivityManager {
    constructor(options = {}) {
        this.ajaxUrl = window.docuswiftPortal?.ajax_url || '/wp-admin/admin-ajax.php';
        this.nonce = window.docuswiftPortal?.nonce || '';
        this.timeout = 15 * 60 * 1000; // 15 minutes
        this.remaining = this.timeout;
        this.timer = null;
        this.countdownInterval = null;
        this.started = false;

        this.events = ['mousemove','keydown','scroll','click','touchstart'];
        this.handleActivity = this.handleActivity.bind(this);
    }

    init() {
        // Only start if the user is logged in
        if (!window.docuswiftPortal?.is_logged_in) {
            // console.log('User not logged in - inactivity manager disabled');
            return;
        }

        console.log('InactivityManager initialized');
        this.events.forEach(event => {
            document.addEventListener(event, this.handleActivity, { passive: true });
        });
    }

    handleActivity() {
        if (!this.started) {
            this.started = true;
            // console.log('User activity detected - starting inactivity timer');
        } else {
            // console.log('User activity detected - resetting inactivity timer');
        }
        this.resetTimer();
    }

    resetTimer() {
        clearTimeout(this.timer);
        clearInterval(this.countdownInterval);
        this.remaining = this.timeout;

        // Start inactivity timeout
        this.timer = setTimeout(() => {
            // console.log('Inactivity timer reached timeout, pinging server...');
            fetch(this.ajaxUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: `action=update_user_activity&nonce=${encodeURIComponent(this.nonce)}`
            })
            .then(res => res.json())
            .then(data => {
                if (data.success === false && data.data?.redirect) {
                    // console.log('User is logged out, showing alert...');
                    alert('You have been logged out due to inactivity.');
                    window.location.href = data.data.redirect;
                } else {
                    // console.log('User still active on server');
                }
            })
            .catch(() => console.log('Failed to ping server'));
        }, this.timeout);

        // console.log('Inactivity timer reset');
    }

    destroy() {
        clearTimeout(this.timer);
        clearInterval(this.countdownInterval);
        // console.log('InactivityManager destroyed');
    }
}